let intervalId = null;
window._satellite = window._satellite || {};
window._satellite.track = window._satellite.track || function() {};

window.addEventListener('load', () => {
    'use strict';

    setTimeout(() => {
        if (performance.getEntriesByType('navigation').length > 0) {
            const timing = performance.getEntriesByType('navigation')[0];

            const metrics = {
                'End User Response Time': timing.loadEventEnd + ' ms',
                'DOM Ready Time': timing.domContentLoadedEventEnd + ' ms',
                'First Byte Time': timing.responseStart + ' ms',
                'Server Connection Time': timing.connectEnd - timing.connectStart + ' ms',
                'Response Available Time': timing.responseEnd - timing.requestStart + ' ms',
                'HTML Download Time': timing.responseEnd - timing.responseStart + ' ms',
                'DOM Building Time': timing.domInteractive - timing.responseEnd + ' ms',
                'Resource Fetch Time': timing.loadEventEnd - timing.domContentLoadedEventEnd + ' ms'
            };

            console.table(metrics);
        } else {
            console.warn('Performance timing data is not available.');
        }
    }, 0);
});


/**
 * Example usage for globals
 * this global util returning currency number with comma
 * example: 1200 = 1,200
 * @param {string} currency - Currency to display before number value
 * @param {*} number
 */
globals.formatCurrency = function (currency, number) {
    'use strict';

    var curr = (currency === null) ? '$' : currency;
    return curr + ' ' + number.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
};

/**
 *
 * @param {*} currency
 * @param {*} number
 * @param {*} resellerDecimalPoints
 * @returns {string}
 */
globals.formatCurrencyWithDecimals = function (currency, number, resellerDecimalPoints) {
    'use strict';

    var curr = (currency === null) ? '$' : currency;
    return curr + ' ' + number.toLocaleString('en-US', {minimumFractionDigits: resellerDecimalPoints, maximumFractionDigits: resellerDecimalPoints});
};

/**
 * Validate phone number
 * @param {*} phone
 * @returns {boolean}
 */
globals.validatePhoneNumber = function (phone) {
    'use strict';

    var regex = /^(((\+?1[ ])?(((\([0-9]{3}\)|[0-9]{3})[ ]?[0-9]{3}[ ]?[0-9]{4})|((\([0-9]{3}\)|[0-9]{3})[\.]?[0-9]{3}[\.]?[0-9]{4})|((\([0-9]{3}\)|[0-9]{3})[-]?[0-9]{3}[-]?[0-9]{4})))|((\+?1)?[0-9]{10}))$/;
    return regex.test(phone);
};

/**
 * Validate email
 * @param {string} email
 * @returns {boolean}
 */
globals.validateEmail = function (email) {
    'use strict';

    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
};

/**
 * Validate date
 * @param {string} date
 * @returns {boolean}
 */
globals.validateDate = function (date) {
    'use strict';

    var useStrictParsing = true;

    if (date) {
        return moment(date, dateFormat, useStrictParsing).isValid();
    }
};

/**
 * Compare valid dateFormat(Global Variable in master.tag) of datel and date2
 * @param {string} date1
 * @param {string} date2
 * @returns {boolean} true when date1 less than date2
 */
globals.compareDates = function (date1, date2) {
    'use strict';

    var useStrictParsing = true;

    if (date1 && date2) {
        var momentDate1 = moment(date1, dateFormat, useStrictParsing);
        var momentDate2 = moment(date2, dateFormat, useStrictParsing);
        return momentDate2.diff(momentDate1, 'days', true) >= 0;
    }
};

/**
 * Check if a field input matches the specified pattern.
 * Note: use with `input` and `paste` handlers. `keyup` doesn't work on Chrome Android.
 * Inspiration: http://therealmofcode.com/posts/2014/03/where-is-keypress-event-chrome-android.html
 * @param {string} regex - Pattern to validate against
 * @param {Object} event - Passed event handler
 */
globals.blockInput = function (regex, event) {
    'use strict';

    var input = $(event.target);

    /**
     *
     * @param {*} val
     * @param {*} oldVal
     * @returns {string}
     */
    function findDelta(val, oldVal) {
        var delta = '';
        for (var i = 0; i < val.length; i++) {
            var str = val.substr(0, i) + val.substr(i + val.length - oldVal.length);
            if (str === oldVal) {
                delta = val.substr(i, val.length - oldVal.length);
            }
        }

        return delta;
    }

    /**
     * Validate the char
     * @param {*} char
     * @returns {boolean}
     */
    function isValidChar(char) {
        return new RegExp(regex).test(char);
    }

    /**
     * Validate the string
     * @param {*} str
     * @returns {boolean}
     */
    function isValidString(str) {
        //noinspection LoopStatementThatDoesntLoopJS
        for (var i = 0; i < str.length; i++) {

            return isValidChar(str.substr(i, 1));
        }
    }

    var val = input.val();
    var oldVal = input.data('oldVal') || '';
    var inserted = findDelta(val, oldVal);
    var removed = findDelta(oldVal, val);
    if (event.type === 'paste') {
        if (!isValidString(val)) {
            input.val(oldVal);
        }
    }

    if (!removed) {
        if (!isValidChar(inserted)) {
            input.val(oldVal);
        }
    }

    input.data('oldVal', input.val());
};

/* temporary functions from the order entry prototype which will ultimately be refactored
 once the back end data sources are established.
 */

/**
 * Get Url Params as Array
 * @returns {*}
 */
globals.findGetParameter = function (parameterName) {
    'use strict';

    var result = null;
    var tmp = [];
    var items = location.search.substr(1).split('&');

    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split('=');

        if (tmp[0] === parameterName) {
            result = decodeURIComponent(tmp[1]);
        }
    }

    return result;
};

/**
 * Is IE
 * @returns {*}
 */
globals.isWindows = function detectIE() {
    'use strict';

    return navigator.platform === 'Win32' || navigator.platform === 'Win64';
};

/**
 * Format Currency
 * @param {number} integer
 * @returns {string}
 */
globals.formatCurrencyOrder = function (integer) {
    'use strict';

    return parseFloat(integer).toLocaleString();
};

/**
 * Parse Percentage
 * @param {number} integer
 * @returns {string}
 */
globals.parsePercentage = function (integer) {
    'use strict';

    return parseFloat(integer).toFixed(2);
};

/**
 * If the application's UI is not being blocked,
 * block it.
 *
 * @see http://malsup.com/jquery/block/#options
 * @param {Object} [options] - Any optional options to block the UI with.
 */
globals.disableApp = function(options) {
    'use strict';

    // Override default disableApp blockUI options with the caller's preferences
    options = options || {};
    options = $.extend({
        message: '&nbsp;',
        baseZ: 1000000,
        css: {
            backgroundImage: "url('" + themeResourcePath + "/images/large_spinner.gif')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            backgroundColor: 'transparent',
            border: '0'
        },
        overlayCSS: {
            backgroundColor: '#FFF',
            opacity: 0.4
        }
    }, options);

    // Block the UI
    $.blockUI(options);
};

/**
 * If the application's UI is being blocked,
 * unblock it.
 */
globals.enableApp = function() {
    'use strict';

    // Unblock the UI
    $.unblockUI();
};

/**
 * If the application's UI is being blocked, unblock it;
 * if the applications UI is not being blocked, block it.
 */
globals.toggleApp = function() {
    'use strict';

    // Toggle the application
    if ($(window).data('blockUI.isBlocked')) {
        globals.enableApp();
    }
    else {
        globals.disableApp();
    }
};

globals.addTextSpinner = function (place) {
    'use strict';

    place.html(`
        <div class="spinner">
            <img src="/orderentry/_ui/desktop/theme-westcon/images/large_spinner.gif" alt="" style="width: 25px;">
        </div>
    `);
};

/**
 * Get the code of the key pressed from the event of that press.
 * @param  {Object} event
 * @return {number}
 */
globals.getKeyCodeFromEvent = function (event) {
    'use strict';
    return (event.which || event.keyCode);
};

/**
 * Get the char from the key pressed from the event of that press.
 * @param  {Object} event
 * @return {string}
 */
globals.getCharFromEvent = function (event) {
    'use strict';
    return String.fromCharCode(globals.getKeyCodeFromEvent(event));
};

/**
 * Is Enter Key will return true if the event object correspond to the Enter key
 * pressed from the keyboard.
 * @param {Object} event - DOM event object
 */
globals.isEnterKey = function (event) {
    'use strict';
    return (globals.getKeyCodeFromEvent(event) === 13);
};
/* Attack value Special character Check */
globals.attackValueCheck = function (e) {
    'use strict';
    if ($('#XSSSanitizationValidationEnabled').val() === false || $('#XSSSanitizationValidationEnabled').val() === 'false') {
        let spChar = /[`!@%^*_+=\[\]{};:|,.<>?~]/;
        if (spChar.test(e.target.value)) {
            var txt = e.target.value.replace(/[`!@%^*_+=\[\]{};:|,.<>?~]/gi, '');
            e.preventDefault();
            $(e.target).val(txt);
            this.eventAgg.trigger('specialCharactersValidationModal');
            return false;
        }
    }
};

globals.encryptString = function (plaintext) {
    'use strict';
    const secretKey = 'mySecretKey';
    const ciphertext = CryptoJS.AES.encrypt(plaintext, secretKey).toString();
    return ciphertext;
};

globals.parseDateByFormat = function (dateStr) {
    'use strict';

    const formatParts = dateFormat.split('/');
    const dateParts = dateStr.split('/');
    let day, month, year;
    formatParts.forEach((part, idx) => {
        const value = parseInt(dateParts[idx], 10);
        if (part === 'DD') {
            day = value;
        } else if (part === 'MM') {
            month = value - 1;
        } else if (part === 'YYYY') {
            year = value;
        }
    });

    return new Date(year, month, day);
};

globals.encodeString = function (plaintext) {
    'use strict';
    const encoder = new TextEncoder();
    const encodedBytes = encoder.encode(plaintext);
    return btoa(String.fromCharCode(...encodedBytes));
};

globals.validateStringForXss = function (plaintext) {
    'use strict';
    const regex = /<script\b|on\w+\s*=|<\/?[a-z][\s\S]*>/i;
    return regex.test(plaintext);
};

globals.getProgressStatus = function (status, clearIntervalFlag, isGrid, keepAppDisable) {
    'use strict';
    let quoteStatus = $('#quoteLockedClose').data('json');
    if (quoteStatus.lockedByOtherUser) {
        return;
    }

    let isStatusTrueOnce = status;
    if (!clearIntervalFlag) {
        if (isGrid === true) {
            $('.comp-quote-detail-col-headers .spinner-text').text('Do not Refresh the page or click on the back button');
        } else {
            globals.disableApp();
            if ($('.submit-spinner-text').length === 0) {
                $('body').append(`
                    <div class='submit-spinner-text'><p>Do not Refresh the page or click on the back button</p></div>
                `);
            }
        }

        let url = '/quote/quoteDetail/extsysteminprogresschecks/' + $('#quoteCode').val();
        const fetchStatus = () => {
            $.ajax({
                type: 'GET',
                url: url,
                success: (response) => {
                    if (response.extInProgressMsg) {
                        if (isGrid === true) {
                            $('.comp-quote-detail-col-headers .spinner-text').text(response.extInProgressMsg);
                        } else {
                            globals.disableApp();
                            $('.submit-spinner-text').text(response.extInProgressMsg);
                        }

                        isStatusTrueOnce = true;
                    } else {
                        if (isStatusTrueOnce) {
                            if (isGrid === true) {
                                $('.comp-quote-detail-col-headers .spinner-text').text('Updating the value...');
                            } else {
                                $('.submit-spinner-text').remove();
                            }

                            if (!keepAppDisable) {
                                globals.enableApp();
                            }

                            clearInterval(intervalId);
                            isStatusTrueOnce = false;
                        }
                    }
                },

                error: (xhr, status, error) => {
                    console.log(error);
                    if (isGrid === true) {
                        $('.comp-quote-detail-col-headers .spinner-text').text('Updating the value...');
                    } else {
                        $('.submit-spinner-text').remove();
                    }

                    globals.enableApp();
                    clearInterval(intervalId);
                    isStatusTrueOnce = false;
                }
            });
        };

        fetchStatus();
        intervalId = setInterval(fetchStatus, 10000);
    } else {
        clearInterval(intervalId);
        if (isGrid === true) {
            $('.comp-quote-detail-col-headers .spinner-text').text('Updating the value...');
        } else {
            $('.submit-spinner-text').remove();
        }

        if (!keepAppDisable) {
            globals.enableApp();
        }

        isStatusTrueOnce = false;
    }
};
